import {
  ChangeDetectorRef,
  Component,
  Injector,
  model,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { StaffManagerService } from '../services/staff-manager.service';
import { EditStaffManagerComponent } from './edit-staff-manager/edit-staff-manager.component';
import { UnitService } from '../services/unit.service';
import { JobTitleService } from '../services/job-title.service';

@Component({
  selector: 'app-staff-manager',
  templateUrl: './staff-manager.component.html',
  styleUrls: ['./staff-manager.component.css'],
})
export class StaffManagerComponent
  extends SecondPageIndexBase
  implements OnInit
{
  code: any;
  setWidth: string = '130%';
  @ViewChild('pEdit', { static: false }) pEdit: EditStaffManagerComponent;
  codeName: any;
  jobTitleId: any;
  unitCode: any;
  listUnitCode: { label: string; value: string }[] = [];
  formGroup: UntypedFormGroup;
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
    { label: 'Tất cả', value: -1 },
  ];
  listJobTitle: { label: string; value: number }[] = [];
  constructor(
    private router: Router,
    private _service: StaffManagerService,
    private _unitService: UnitService,
    private _jobTitleService: JobTitleService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      codeName: new UntypedFormControl(''),
      jobTitleId: new UntypedFormControl(''),
      unitCode: new UntypedFormControl(''),
      status: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'stt',
        header: 'STT',
        visible: true,
        sort: false,
        width: 3,
      },
      {
        field: 'unitName',
        header: 'Tỉnh',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'provinceName',
        header: 'Đơn vị',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'employeeCode',
        header: 'Mã nhân viên',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'employeeName',
        header: 'Tên nhân viên',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'jobTitleName',
        header: 'Chức danh',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'salesChannelName',
        header: 'Kênh bán',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'status',
        header: 'Trạng thái hoạt động',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'managerName',
        header: 'Nhân viên quản lý',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'notes',
        header: 'Ghi chú',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
    this.unitCode = '00';
    this.jobTitleId = 0;
    this.status = -1;
  }
  ngOnInit(): void {
    this.loadUnitCode();
    this.loadJobTitle();
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }
  refresh() {
    this.unitCode = '00';
    this.codeName = '';
    this.jobTitleId = 0;
    this.status = 1;
  }

  loadUnitCode() {
    this._unitService.getAllUnit(null).then((rs) => {
      if (rs) {
        this.listUnitCode = rs?.data?.map((r) => ({
          label: `${r.unitName}`,
          value: r.unitCode,
        }));
        this.listUnitCode.unshift({ label: 'Tổng công ty (00)', value: '00' });
      }
    });
  }

  loadJobTitle() {
    this._jobTitleService.getAllJob(null).then((rs) => {
      if (rs) {
        this.listJobTitle = rs?.data?.map((r) => ({
          label: `${r.name}-(${r.id})`,
          value: r.id,
        }));
        this.listJobTitle.unshift({ label: 'Tất cả', value: 0 });
      }
    });
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      codeName: this.codeName,
      jobTitleId: this.jobTitleId == 0 ? null : this.jobTitleId,
      unitCode: this.unitCode ?? '00',
      status: this.status == -1 ? null : this.status,
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize,
    };
    var index = model.pageNo * model.pageSize;
    this._service
      .getListStaffManager(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          if (this.dataSource) {
            this.dataSource.forEach((e) => {
              index++;
              e.stt = index;
            });
          }
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editStaffManager(item: any, isDisable: boolean) {
    if (item && item.employeeCode)
      var model = {
        employeeCode: item.employeeCode,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }

  deleteStaffManager(item: any) {
    if (item && item.employeeCode && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động nhân viên này')
        .then((res) => {
          if (res) {
            this._service.inactive(item.employeeCode).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }

  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
